import React from "react";
import "./Opinion.css";
import quote from "./../../../../assets/shapes/citat.svg";

const Opinion = function() {
  return (
    <div className="opinion text-center row">
      <div className="col-12">
        <img src={quote} className="quote-image" alt="" />
      </div>
      <div className="col-12 col-md-10 col-lg-8 col-xl-5 mx-auto">
        <p>
        Valet av Corviva har fallit ut bättre än vad vi vågat hoppats på. 
        Corviva ger utrymme för våra önskemål, är transparenta, svarar 
        snabbt och har alltid koll. Det gör att vi känner stort förtroende 
        för Corviva.
        <br/>
        <br/>
        Vi ger Corviva vår varmaste rekommendation!
        <br/>
        <br/>
        <i>
        Gitte Klingspor och Linda Hammar
        </i>
        <br/>
        <i>
        <h6>- Hälsostrateger på Vattenfall</h6>
        </i>
        </p>
      </div>
    </div>
  );
};

export default Opinion;



// WEBPACK FOOTER //
// ./src/routes/StartPage/components/Opinion/Opinion.jsx